import { useQuery } from "@tanstack/react-query";
import { fetchListings, fetchListingBySlug, fetchCitiesAndStates, type ListingFilters } from "@/lib/db/listings";

export function useListingsV2(filters: ListingFilters, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ["listings-v2", filters],
    queryFn: () => fetchListings(filters),
    staleTime: 60_000,
    enabled: options?.enabled,
  });
}

export function useListingV2(slug: string | undefined) {
  return useQuery({
    queryKey: ["listing-v2", slug],
    queryFn: () => fetchListingBySlug(slug!),
    enabled: !!slug,
    staleTime: 60_000,
  });
}

export function useLocationsV2() {
  return useQuery({
    queryKey: ["locations-v2"],
    queryFn: fetchCitiesAndStates,
    staleTime: 5 * 60_000,
  });
}
